import { getBlockedUserIds } from 'hb-react/frontoffice/utils/blockUser';
import { displayXhrError } from 'hb-react/frontoffice/utils/globalUtils';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const fetchFeedItems = ({
  routes,
  page,
  perPage,
  filters,
  onUserCanNotAccessLiveFeed,
}) =>
  axios
    .get(routes.feed_items_path({ page, per_page: perPage, ...filters }))
    .then(({ data }) => {
      // Called models from the network endpoint, posts from the group endpoint. Need to be aligned BE side
      const items = data?.posts || data?.models;
      const total = data?.total_items;
      // Filter Hidden user posts
      const hiddenUserIds = getBlockedUserIds();
      const filteredItems = items.filter(
        (item) => !hiddenUserIds.includes(item?.user?.id),
      );

      return {
        total,
        items: filteredItems,
      };
    })
    .catch((error) => {
      displayXhrError(error);
      if (onUserCanNotAccessLiveFeed && error?.response?.status === 403) {
        onUserCanNotAccessLiveFeed();
      }

      return {};
    });

export default fetchFeedItems;
